import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import BannerListScreen from './screens/BannerListScreen';

import BannerCategoryScreen from './screens/BannerCategoryScreen';

Banner.propTypes = {};

function Banner(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="list" element={<BannerListScreen />} />
                    <Route path="category" element={<BannerCategoryScreen />} />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default Banner;
